<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Antecipações de recebimentos a clientes</h3>
        </div>

        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
              v-b-tooltip.hover.bottom
              title="Filtros"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- Cards -->
      <d-row>
        <d-col
          v-for="(card, index) in Cards"
          :key="index"
          md="10"
          lg="6"
          class="mb-6"
        >
          <cards
            :id="`card-${index}`"
            :label="card.label"
            :value="card.value"
            :small="true"
          />
        </d-col>
      </d-row>
      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Antecipações</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-2">
                  <h6 v-if="pagination.TotalItems > 0" class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0" v-if="pagination.TotalItems > 1">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div
                      class="dropdown-menu"
                      id="dropTableOptions"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader
                            :small="true"
                            :isLoading="loadingReport"
                          ></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">Cliente</th>
                    <th scope="col" class="border-0 text-left">Usuário</th>
                    <th scope="col" class="border-0">Data do pagamento</th>
                    <th scope="col" class="border-0">Valor líquido/bruto</th>
                    <th scope="col" class="border-0">
                      Taxa de antecipação/S2P
                    </th>
                    <th scope="col" class="border-0">Taxa do cliente/S2P</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(advancePayment, index) in advancePayments"
                    :key="index"
                  >
                    <td></td>
                    <td class="text-left">
                      {{ advancePayment.Merchant.Name }}
                    </td>
                    <td class="text-left">
                      <div>{{ advancePayment.User.Name }}</div>
                      <span v-if="!advancePayment.User.Name">INTEGRAÇÃO</span>
                    </td>
                    <td>{{ advancePayment.PaymentDate | date }}</td>
                    <td>
                      <div>
                        {{ advancePayment.AmountNetReceivables | currency }}
                      </div>
                      <span
                        class="td-span-style"
                        v-if="advancePayment.AmountReceivables"
                        >{{ advancePayment.AmountReceivables | currency }}</span
                      >
                    </td>
                    <td>
                      <div>{{ advancePayment.Tax | currency }}</div>
                      <span
                        class="td-span-style"
                        v-if="advancePayment.NegotiationTaxMarketplace > 0"
                        >{{ advancePayment.AmountProvider | currency }}</span
                      >
                    </td>
                    <td>
                      <div>
                        {{ advancePayment.NegotiationTax | percentage }}
                      </div>
                      <span
                        class="td-span-style"
                        v-if="advancePayment.NegotiationTaxMarketplace > 0"
                        >{{
                          advancePayment.NegotiationTaxMarketplace | percentage
                        }}</span
                      >
                    </td>
                    <td></td>
                  </tr>
                  <tr
                    v-if="
                      advancePayments == undefined ||
                      advancePayments == null ||
                      advancePayments.length == 0
                    "
                  >
                    <td colspan="9">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <input
            placeholder="Cliente"
            type="text"
            class="form-control"
            v-model="filter.NameMerchant"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col md="6" class="form-group">
          <label>Data inicial</label>
          <date-field v-model="filter.PaymentDateInitial" />
        </d-col>
        <d-col md="6" class="form-group">
          <label>Data final</label>
          <date-field v-model="filter.PaymentDateEnd" />
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import cards from "@/components/common/cards";
import DateField from "../common/date-field";
import decimalField from "../common/decimal-field.vue";

export default {
  name: "advance-payments",
  components: {
    cards,
    DateField,
    decimalField,
  },
  data: function () {
    return {
      countFilter: 0,
      filter: {
        NameMerchant: null,
        PaymentDateInitial: this.$options.filters.firstDayOfMonth(
          new Date(),
          "YYYY-MM-DD"
        ),
        PaymentDateEnd: this.$options.filters.lastDayOfMonth(
          new Date(),
          "YYYY-MM-DD"
        ),
      },
      loadingList: false,
      loadingReport: false,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      infoAdvancePayment: {
        AmountNetReceivablesTotal: 0,
        TaxTotal: 0,
      },
      advancePayments: [],
      merchants: [],
    };
  },
  computed: {
    Cards() {
      return [
        {
          label: "Valor líquido total",
          value: this.$options.filters.currency(
            this.infoAdvancePayment.AmountNetReceivablesTotal
          ),
        },
        {
          label: "Taxa S2P total",
          value: this.$options.filters.currency(
            this.infoAdvancePayment.TaxTotal
          ),
        },
      ];
    },
  },
  watch: {
    "filter.PaymentDateInitial": function (nv, ov) {
      if (nv != null && nv > this.filter.PaymentDateEnd) {
        this.filter.PaymentDateEnd = nv;
      }
    },
    "filter.PaymentDateEnd": function (nv, ov) {
      if (nv != null && nv < this.filter.PaymentDateInitial) {
        this.filter.PaymentDateInitial = nv;
      }
    },
    "pagination.PageNumber": function () {
      this.ListAdvancePayment();
    },
    "pagination.RowsPerPage": function () {
      this.ListAdvancePayment();
    },
  },
  mounted() {
    this.ListAdvancePayment();
  },
  methods: {
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListAdvancePayment();
    },
    GetReport: function (ev) {
      ev.preventDefault();
      this.loadingReport = true;
      let data = this.GetParamsData(false);
      this.$store
        .dispatch("ReportAdvancePayment", { params: data })
        .then((response) => {
          if (
            response.UrlReport != null &&
            response.UrlReport != undefined &&
            response.UrlReport != ""
          ) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              "Relatório gerado com sucesso"
            );
            window.open(response.UrlReport, "_self");
          }
        })
        .catch((error) => {
          this.$makeToast(
            "Tente novamente mais tarde.",
            "danger",
            "Erro ao gerar o relatório",
            error
          );
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    GetParamsData: function (deletePagination = false) {
      let data = {
        ...this.pagination,
        "Object.Merchant.Name": this.filter.NameMerchant,
        PaymentDateInitial: this.filter.PaymentDateInitial,
        PaymentDateEnd: this.filter.PaymentDateEnd,
      };
      delete data.TotalItems;
      if (deletePagination) {
        delete data.RowsPerPage;
        delete data.PageNumber;
      }
      return data;
    },
    ListAdvancePayment: function () {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.NameMerchant)) this.countFilter++;
      if (
        hasValue(this.filter.PaymentDateInitial) ||
        hasValue(this.filter.PaymentDateEnd)
      )
        this.countFilter++;
      let data = this.GetParamsData();
      this.$store
        .dispatch("ListAdvancePayment", { params: data })
        .then((response) => {
          this.advancePayments = response.Objects;
          this.infoAdvancePayment = {
            AmountNetReceivablesTotal: response.AmountNetReceivablesTotal,
            TaxTotal: response.TaxTotal,
          };
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            "Tente atualizar a página.",
            "danger",
            "Erro ao listar as comissões",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    ResetFilter: function () {
      this.filter = {
        NameMerchant: null,
        PaymentDateInitial: this.$options.filters.firstDayOfMonth(
          new Date(),
          "YYYY-MM-DD"
        ),
        PaymentDateEnd: this.$options.filters.lastDayOfMonth(
          new Date(),
          "YYYY-MM-DD"
        ),
      };
      this.ListAdvancePayment();
    },
  },
};
</script>

<style scoped>
.td-span-style {
  font-size: 10pt;
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/advancePayments.vue